import { BaseFilter } from '@/_store/offers/offers.types';

export enum TopSearchDropdownItemMode {
	LOCATIONS = 'locations',
	DATE_RANGE = 'offersDateRange',
	STOPS = 'stops',
	PARTICIPANTS = 'participants',
	KINDS = 'kinds',
	BOARDS = 'boards',
	CONVENIENCES = 'conveniences',
	NIGHTS = 'nights',
	SEARCH = 'search',
	PRICE = 'price',
}

enum ExtendedTopSearchDropdownItemMode {
	ADULTS = 'adults',
	CHILDREN = 'children',
}

export enum ExtendedTopSearchItemModeWithSearchInput {
	SEARCH = 'search',
}

export enum TopSearchItemModeTransportKind {
	TRANSPORT_KIND = 'transportKind',
}

const CombinedTopSearchDropdownItemMode = {
	...TopSearchDropdownItemMode,
	...ExtendedTopSearchDropdownItemMode,
	...ExtendedTopSearchItemModeWithSearchInput,
} as const;

const { ...CombinedTopSearchDropdownItemModeWithoutParticipants } = CombinedTopSearchDropdownItemMode;

export const OfferListHeaderItemMode = {
	...CombinedTopSearchDropdownItemModeWithoutParticipants,
	...TopSearchItemModeTransportKind,
};

export const MultiChoiceModes: TopSearchDropdownItemMode[] = [
	TopSearchDropdownItemMode.LOCATIONS,
	TopSearchDropdownItemMode.STOPS,
	TopSearchDropdownItemMode.KINDS,
	TopSearchDropdownItemMode.BOARDS,
	TopSearchDropdownItemMode.CONVENIENCES,
];

export const CounteringModes: TopSearchDropdownItemMode[] = [
	TopSearchDropdownItemMode.PARTICIPANTS,
	TopSearchDropdownItemMode.NIGHTS,
];
export enum DropdownType {
	MULTI = 'multi',
	COUNTER = 'counter',
	DATE = 'date',
	SEARCH = 'search',
	PRICE = 'price',
}

export enum Participant {
	ADULTS = 'Dorośli',
	CHILDREN = 'Dzieci (0-12 lat)',
}

export enum Nights {
	FROM = 'Od',
	TO = 'Do',
}

export interface Row {
	rowName: Participant | Nights;
	options: number[];
}

export interface RowValue {
	value: number;
	type: Participant | Nights;
}

export enum TopSearchFilterElType {
	BTN,
	INPUT,
}

export interface SearchResult {
	locations: BaseFilter[];
	products: BaseFilter[];
}
